import { render, staticRenderFns } from "./platGoods.vue?vue&type=template&id=7664d8b9&"
import script from "./platGoods.vue?vue&type=script&lang=js&"
export * from "./platGoods.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports